import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/deck.gl/playground',
    component: ComponentCreator('/deck.gl/playground', '4f0'),
    exact: true
  },
  {
    path: '/deck.gl/showcase',
    component: ComponentCreator('/deck.gl/showcase', '7b7'),
    exact: true
  },
  {
    path: '/deck.gl/docs',
    component: ComponentCreator('/deck.gl/docs', 'b97'),
    routes: [
      {
        path: '/deck.gl/docs',
        component: ComponentCreator('/deck.gl/docs', 'e6f'),
        routes: [
          {
            path: '/deck.gl/docs',
            component: ComponentCreator('/deck.gl/docs', 'ac2'),
            routes: [
              {
                path: '/deck.gl/docs',
                component: ComponentCreator('/deck.gl/docs', '693'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/aggregation-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/aggregation-layer', 'e65'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/aggregator',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/aggregator', 'cfb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/contour-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/contour-layer', 'f01'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/cpu-aggregator',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/cpu-aggregator', '93f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/grid-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/grid-layer', '86e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/heatmap-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/heatmap-layer', '878'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/hexagon-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/hexagon-layer', '121'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/overview', '9b0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/screen-grid-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/screen-grid-layer', '1ef'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/aggregation-layers/webgl-aggregator',
                component: ComponentCreator('/deck.gl/docs/api-reference/aggregation-layers/webgl-aggregator', '8c4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/arcgis/deck-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/arcgis/deck-layer', '64a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/arcgis/deck-renderer',
                component: ComponentCreator('/deck.gl/docs/api-reference/arcgis/deck-renderer', 'd82'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/arcgis/load-arcgis-modules',
                component: ComponentCreator('/deck.gl/docs/api-reference/arcgis/load-arcgis-modules', '510'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/arcgis/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/arcgis/overview', '976'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/basemap',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/basemap', '98c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/cluster-tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/cluster-tile-layer', '983'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/data-sources',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/data-sources', 'aaa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/fetch-map',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/fetch-map', 'c51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/h3-tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/h3-tile-layer', '87a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/heatmap-tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/heatmap-tile-layer', 'dff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/overview', '0aa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/point-label-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/point-label-layer', 'db2'),
                exact: true
              },
              {
                path: '/deck.gl/docs/api-reference/carto/quadbin-tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/quadbin-tile-layer', 'f70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/raster-tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/raster-tile-layer', '9c2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/styles',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/styles', '89c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/carto/vector-tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/carto/vector-tile-layer', '4ec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/ambient-light',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/ambient-light', '7b0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/attribute',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/attribute', '803'),
                exact: true
              },
              {
                path: '/deck.gl/docs/api-reference/core/attribute-manager',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/attribute-manager', '681'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/camera-light',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/camera-light', '7b2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/composite-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/composite-layer', 'ecd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/controller', 'dc1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/deck',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/deck', '9d2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/deckgl',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/deckgl', '533'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/directional-light',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/directional-light', '3f9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/first-person-controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/first-person-controller', '5b3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/first-person-view',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/first-person-view', '4f1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/fly-to-interpolator',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/fly-to-interpolator', '039'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/globe-controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/globe-controller', '16d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/globe-view',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/globe-view', 'ecf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/globe-viewport',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/globe-viewport', '777'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/layer', '0a4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/layer-manager',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/layer-manager', 'ea0'),
                exact: true
              },
              {
                path: '/deck.gl/docs/api-reference/core/lighting-effect',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/lighting-effect', '0ee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/linear-interpolator',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/linear-interpolator', '2e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/map-controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/map-controller', '59f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/map-view',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/map-view', 'a8c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/orbit-controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/orbit-controller', 'd6e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/orbit-view',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/orbit-view', '4e8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/orthographic-controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/orthographic-controller', '0b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/orthographic-view',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/orthographic-view', 'd7b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/point-light',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/point-light', '6ab'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/post-process-effect',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/post-process-effect', '0ee'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/project',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/project', '6be'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/project32',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/project32', 'df9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/project64',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/project64', 'e3b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/sun-light',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/sun-light', 'b80'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/terrain-controller',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/terrain-controller', '5f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/transition-interpolator',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/transition-interpolator', '6ca'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/view',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/view', 'adb'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/viewport',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/viewport', '4b6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/web-mercator-viewport',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/web-mercator-viewport', 'af8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/core/widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/core/widget', 'ea7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/brushing-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/brushing-extension', 'ed3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/clip-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/clip-extension', '5aa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/collision-filter-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/collision-filter-extension', '897'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/data-filter-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/data-filter-extension', '018'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/fill-style-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/fill-style-extension', '912'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/fp64-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/fp64-extension', '1b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/mask-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/mask-extension', 'a70'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/overview', 'c69'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/path-style-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/path-style-extension', 'a2d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/extensions/terrain-extension',
                component: ComponentCreator('/deck.gl/docs/api-reference/extensions/terrain-extension', 'b64'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/a5-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/a5-layer', '51f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/geohash-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/geohash-layer', 'fba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/great-circle-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/great-circle-layer', '11f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/h3-cluster-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/h3-cluster-layer', '46f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/h3-hexagon-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/h3-hexagon-layer', '2e3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/mvt-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/mvt-layer', '27f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/quadkey-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/quadkey-layer', '42e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/s2-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/s2-layer', 'cf5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/terrain-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/terrain-layer', '9ba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/tile-3d-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/tile-3d-layer', 'b77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/tile-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/tile-layer', '083'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/trips-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/trips-layer', 'd83'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/geo-layers/wms-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/geo-layers/wms-layer', '6c1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/google-maps/google-maps-overlay',
                component: ComponentCreator('/deck.gl/docs/api-reference/google-maps/google-maps-overlay', '33d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/google-maps/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/google-maps/overview', '524'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/json/conversion-reference',
                component: ComponentCreator('/deck.gl/docs/api-reference/json/conversion-reference', 'c14'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/json/json-configuration',
                component: ComponentCreator('/deck.gl/docs/api-reference/json/json-configuration', '71c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/json/json-converter',
                component: ComponentCreator('/deck.gl/docs/api-reference/json/json-converter', 'c5f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/json/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/json/overview', '6f8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers', '88f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/arc-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/arc-layer', '1e4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/bitmap-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/bitmap-layer', '051'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/column-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/column-layer', 'd76'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/geojson-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/geojson-layer', '278'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/grid-cell-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/grid-cell-layer', 'dec'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/icon-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/icon-layer', '82e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/line-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/line-layer', '47c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/path-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/path-layer', 'c42'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/point-cloud-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/point-cloud-layer', '788'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/polygon-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/polygon-layer', 'adc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/scatterplot-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/scatterplot-layer', '61e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/solid-polygon-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/solid-polygon-layer', '7e9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/layers/text-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/layers/text-layer', '60f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/mapbox/mapbox-overlay',
                component: ComponentCreator('/deck.gl/docs/api-reference/mapbox/mapbox-overlay', '8f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/mapbox/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/mapbox/overview', 'd02'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/mesh-layers/scenegraph-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/mesh-layers/scenegraph-layer', '9ff'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/mesh-layers/simple-mesh-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/mesh-layers/simple-mesh-layer', 'd9a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/react/deckgl',
                component: ComponentCreator('/deck.gl/docs/api-reference/react/deckgl', '220'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/react/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/react/overview', '223'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/react/use-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/react/use-widget', 'a29'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/test-utils/generate-layer-tests',
                component: ComponentCreator('/deck.gl/docs/api-reference/test-utils/generate-layer-tests', 'dfc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/test-utils/interaction-test-runner',
                component: ComponentCreator('/deck.gl/docs/api-reference/test-utils/interaction-test-runner', 'b01'),
                exact: true
              },
              {
                path: '/deck.gl/docs/api-reference/test-utils/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/test-utils/overview', '3b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/test-utils/snapshot-test-runner',
                component: ComponentCreator('/deck.gl/docs/api-reference/test-utils/snapshot-test-runner', '4a2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/test-utils/test-layer',
                component: ComponentCreator('/deck.gl/docs/api-reference/test-utils/test-layer', 'd84'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/compass-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/compass-widget', '64c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/context-menu-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/context-menu-widget', 'd1f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/fullscreen-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/fullscreen-widget', '69f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/geocoder-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/geocoder-widget', '0b8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/gimbal-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/gimbal-widget', '7f0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/icon-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/icon-widget', 'b7a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/info-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/info-widget', '7e2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/loading-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/loading-widget', '43b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/overview',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/overview', '4a6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/popup-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/popup-widget', 'a77'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/reset-view-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/reset-view-widget', 'e06'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/scale-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/scale-widget', 'a85'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/screenshot-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/screenshot-widget', 'fbd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/scrollbar-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/scrollbar-widget', '618'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/selector-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/selector-widget', '05b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/splitter-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/splitter-widget', '090'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/stats-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/stats-widget', '002'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/styling',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/styling', 'b72'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/theme-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/theme-widget', '217'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/timeline-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/timeline-widget', '133'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/toggle-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/toggle-widget', '530'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/api-reference/widgets/zoom-widget',
                component: ComponentCreator('/deck.gl/docs/api-reference/widgets/zoom-widget', '3f4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/contributing',
                component: ComponentCreator('/deck.gl/docs/contributing', '56b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/animations-and-transitions',
                component: ComponentCreator('/deck.gl/docs/developer-guide/animations-and-transitions', 'd5a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/base-maps/using-with-3d-tiles',
                component: ComponentCreator('/deck.gl/docs/developer-guide/base-maps/using-with-3d-tiles', 'cb3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/base-maps/using-with-arcgis',
                component: ComponentCreator('/deck.gl/docs/developer-guide/base-maps/using-with-arcgis', '594'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/base-maps/using-with-google-maps',
                component: ComponentCreator('/deck.gl/docs/developer-guide/base-maps/using-with-google-maps', '3f3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/base-maps/using-with-mapbox',
                component: ComponentCreator('/deck.gl/docs/developer-guide/base-maps/using-with-mapbox', 'b14'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/base-maps/using-with-maplibre',
                component: ComponentCreator('/deck.gl/docs/developer-guide/base-maps/using-with-maplibre', '8da'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/building-apps',
                component: ComponentCreator('/deck.gl/docs/developer-guide/building-apps', '52a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/coordinate-systems',
                component: ComponentCreator('/deck.gl/docs/developer-guide/coordinate-systems', '5c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers', '8ce'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/attribute-management',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/attribute-management', 'fac'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/composite-layers',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/composite-layers', 'bfe'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/layer-attributes',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/layer-attributes', '81c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/layer-extensions',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/layer-extensions', 'a3f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/layer-lifecycle',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/layer-lifecycle', 'd26'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/picking',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/picking', '0e3'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/primitive-layers',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/primitive-layers', 'a36'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/prop-types',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/prop-types', '4f6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/subclassed-layers',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/subclassed-layers', '3d5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/custom-layers/writing-shaders',
                component: ComponentCreator('/deck.gl/docs/developer-guide/custom-layers/writing-shaders', 'aba'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/debugging',
                component: ComponentCreator('/deck.gl/docs/developer-guide/debugging', 'e45'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/fp64',
                component: ComponentCreator('/deck.gl/docs/developer-guide/fp64', 'c79'),
                exact: true
              },
              {
                path: '/deck.gl/docs/developer-guide/interactivity',
                component: ComponentCreator('/deck.gl/docs/developer-guide/interactivity', '96a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/loading-data',
                component: ComponentCreator('/deck.gl/docs/developer-guide/loading-data', '035'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/performance',
                component: ComponentCreator('/deck.gl/docs/developer-guide/performance', 'bcf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/testing',
                component: ComponentCreator('/deck.gl/docs/developer-guide/testing', '88d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/tips-and-tricks',
                component: ComponentCreator('/deck.gl/docs/developer-guide/tips-and-tricks', '366'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/using-effects',
                component: ComponentCreator('/deck.gl/docs/developer-guide/using-effects', '382'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/using-layers',
                component: ComponentCreator('/deck.gl/docs/developer-guide/using-layers', 'caf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/views',
                component: ComponentCreator('/deck.gl/docs/developer-guide/views', '539'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/developer-guide/webgpu',
                component: ComponentCreator('/deck.gl/docs/developer-guide/webgpu', '0b4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/faq',
                component: ComponentCreator('/deck.gl/docs/faq', 'e37'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/get-started/getting-started',
                component: ComponentCreator('/deck.gl/docs/get-started/getting-started', '7af'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/get-started/learning-resources',
                component: ComponentCreator('/deck.gl/docs/get-started/learning-resources', 'b42'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/get-started/using-standalone',
                component: ComponentCreator('/deck.gl/docs/get-started/using-standalone', '6b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/get-started/using-with-map',
                component: ComponentCreator('/deck.gl/docs/get-started/using-with-map', '43e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/get-started/using-with-react',
                component: ComponentCreator('/deck.gl/docs/get-started/using-with-react', '9d6'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/get-started/using-with-typescript',
                component: ComponentCreator('/deck.gl/docs/get-started/using-with-typescript', 'd16'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/roadmap',
                component: ComponentCreator('/deck.gl/docs/roadmap', '1e4'),
                exact: true
              },
              {
                path: '/deck.gl/docs/TEST-STATUS',
                component: ComponentCreator('/deck.gl/docs/TEST-STATUS', 'a5c'),
                exact: true
              },
              {
                path: '/deck.gl/docs/upgrade-guide',
                component: ComponentCreator('/deck.gl/docs/upgrade-guide', 'e49'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/deck.gl/docs/whats-new',
                component: ComponentCreator('/deck.gl/docs/whats-new', '27d'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/deck.gl/examples',
    component: ComponentCreator('/deck.gl/examples', 'd16'),
    routes: [
      {
        path: '/deck.gl/examples',
        component: ComponentCreator('/deck.gl/examples', 'f5b'),
        routes: [
          {
            path: '/deck.gl/examples',
            component: ComponentCreator('/deck.gl/examples', 'eeb'),
            routes: [
              {
                path: '/deck.gl/examples',
                component: ComponentCreator('/deck.gl/examples', '478'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/arc-layer',
                component: ComponentCreator('/deck.gl/examples/arc-layer', '2f5'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/arcgis',
                component: ComponentCreator('/deck.gl/examples/arcgis', '66a'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/brushing-extension',
                component: ComponentCreator('/deck.gl/examples/brushing-extension', '95b'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/carto',
                component: ComponentCreator('/deck.gl/examples/carto', '7f3'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/collision-filter-extension',
                component: ComponentCreator('/deck.gl/examples/collision-filter-extension', '5bf'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/contour-layer',
                component: ComponentCreator('/deck.gl/examples/contour-layer', 'b34'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/data-filter-extension',
                component: ComponentCreator('/deck.gl/examples/data-filter-extension', 'f80'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/first-person-view',
                component: ComponentCreator('/deck.gl/examples/first-person-view', '4f1'),
                exact: true
              },
              {
                path: '/deck.gl/examples/geojson-layer-paths',
                component: ComponentCreator('/deck.gl/examples/geojson-layer-paths', '74a'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/geojson-layer-polygons',
                component: ComponentCreator('/deck.gl/examples/geojson-layer-polygons', 'a82'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/global-grids',
                component: ComponentCreator('/deck.gl/examples/global-grids', '52e'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/globe-view',
                component: ComponentCreator('/deck.gl/examples/globe-view', 'f51'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/google-3d-tiles',
                component: ComponentCreator('/deck.gl/examples/google-3d-tiles', 'bf3'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/google-maps',
                component: ComponentCreator('/deck.gl/examples/google-maps', '9f5'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/heatmap-layer',
                component: ComponentCreator('/deck.gl/examples/heatmap-layer', '219'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/hexagon-layer',
                component: ComponentCreator('/deck.gl/examples/hexagon-layer', '191'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/icon-layer',
                component: ComponentCreator('/deck.gl/examples/icon-layer', '824'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/line-layer',
                component: ComponentCreator('/deck.gl/examples/line-layer', '448'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/mapbox',
                component: ComponentCreator('/deck.gl/examples/mapbox', '15e'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/maplibre',
                component: ComponentCreator('/deck.gl/examples/maplibre', '47a'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/mask-extension',
                component: ComponentCreator('/deck.gl/examples/mask-extension', 'd3a'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/multi-view',
                component: ComponentCreator('/deck.gl/examples/multi-view', '060'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/orthographic-view',
                component: ComponentCreator('/deck.gl/examples/orthographic-view', '2ef'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/plot',
                component: ComponentCreator('/deck.gl/examples/plot', '8fb'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/point-cloud-layer',
                component: ComponentCreator('/deck.gl/examples/point-cloud-layer', '3b9'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/scatterplot-layer',
                component: ComponentCreator('/deck.gl/examples/scatterplot-layer', '670'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/scenegraph-layer',
                component: ComponentCreator('/deck.gl/examples/scenegraph-layer', '9cc'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/screen-grid-layer',
                component: ComponentCreator('/deck.gl/examples/screen-grid-layer', '9ed'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/terrain-extension',
                component: ComponentCreator('/deck.gl/examples/terrain-extension', '4c5'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/terrain-layer',
                component: ComponentCreator('/deck.gl/examples/terrain-layer', '30b'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/text-layer',
                component: ComponentCreator('/deck.gl/examples/text-layer', 'b93'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/text-layer-clipping',
                component: ComponentCreator('/deck.gl/examples/text-layer-clipping', '7e4'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/tile-3d-layer',
                component: ComponentCreator('/deck.gl/examples/tile-3d-layer', '7c0'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/tile-layer',
                component: ComponentCreator('/deck.gl/examples/tile-layer', 'ee9'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/tile-layer-non-geospatial',
                component: ComponentCreator('/deck.gl/examples/tile-layer-non-geospatial', 'd0d'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/trips-layer',
                component: ComponentCreator('/deck.gl/examples/trips-layer', 'dae'),
                exact: true,
                sidebar: "examplesSidebar"
              },
              {
                path: '/deck.gl/examples/wms-layer',
                component: ComponentCreator('/deck.gl/examples/wms-layer', 'ea1'),
                exact: true,
                sidebar: "examplesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/deck.gl/',
    component: ComponentCreator('/deck.gl/', 'd49'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
